module.exports = __webpack_public_path__ + "static/media/scholorimg-3.3820010d.png";